export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getComplaintTypeList: function getComplaintTypeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaint_type/get",
        method: "get",
        params: data
      });
    },
    getSceneList: function getSceneList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaint_type/scene",
        method: "get",
        params: data
      });
    },
    addComplaintType: function addComplaintType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaint_type/add",
        method: "post",
        data: data
      });
    },
    updateComplaintType: function updateComplaintType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaint_type/update",
        method: "post",
        data: data
      });
    },
    deleteComplaintType: function deleteComplaintType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/complaint_type/delete",
        method: "post",
        data: data
      });
    }
  };
});